/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddNoteModel } from '../models/AddNoteModel';
import type { AiAdviceModel } from '../models/AiAdviceModel';
import type { AiAdviceRequestModel } from '../models/AiAdviceRequestModel';
import type { ChangeComplaintStatusModel } from '../models/ChangeComplaintStatusModel';
import type { ComplainSourceEnum } from '../models/ComplainSourceEnum';
import type { ComplaintLogDetailsModel } from '../models/ComplaintLogDetailsModel';
import type { ComplaintLogListItemModelPagedListData } from '../models/ComplaintLogListItemModelPagedListData';
import type { FileModel } from '../models/FileModel';
import type { ModelNote } from '../models/ModelNote';
import type { SaveAiReplyModel } from '../models/SaveAiReplyModel';
import type { SendEmailModel } from '../models/SendEmailModel';
import type { UpdateComplaintLogModel } from '../models/UpdateComplaintLogModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ComplaintLogService {

  /**
   * @param isActive 
   * @param branchId 
   * @param statusId 
   * @param regNo 
   * @param referenceNumber 
   * @param source
 *
 * 0 = Customer
 *
 * 1 = ContactCentre
 *
 * 2 = CSI
 *
 * 3 = ManufactureCustomerService
 *
 * 4 = TMO
 *
 * 5 = GoogleReview
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns ComplaintLogListItemModelPagedListData Success
   * @throws ApiError
   */
  public static getComplaintLog(
isActive?: boolean,
branchId?: number,
statusId?: number,
regNo?: string,
referenceNumber?: string,
source?: ComplainSourceEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<ComplaintLogListItemModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/complaint-log',
      query: {
        'IsActive': isActive,
        'BranchId': branchId,
        'StatusId': statusId,
        'RegNo': regNo,
        'ReferenceNumber': referenceNumber,
        'Source': source,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param formData 
   * @returns ComplaintLogDetailsModel Created
   * @throws ApiError
   */
  public static postComplaintLog(
formData?: {
CustomerName?: string;
CustomerPhone?: string;
CustomerEmail?: string;
RegNo?: string;
BranchId?: number;
ComplaintText?: string;
MarkAsAlert?: boolean;
NoCallNeeded?: boolean;
ReferenceNumber?: string;
Source?: ComplainSourceEnum;
files?: Array<Blob>;
},
): CancelablePromise<ComplaintLogDetailsModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postComplaintLogEmail(
id: number,
requestBody?: SendEmailModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log/{id}/email',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns SendEmailModel Success
   * @throws ApiError
   */
  public static getComplaintLogEmailData(
id: number,
): CancelablePromise<SendEmailModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/complaint-log/{id}/email-data',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postComplaintLogEmailManager(
id: number,
requestBody?: SendEmailModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log/{id}/email-manager',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns ComplaintLogDetailsModel Success
   * @throws ApiError
   */
  public static getComplaintLog1(
id: number,
): CancelablePromise<ComplaintLogDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/complaint-log/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putComplaintLog(
id: number,
requestBody?: UpdateComplaintLogModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/complaint-log/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postComplaintLogClose(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log/{id}/close',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchComplaintLogStatus(
id: number,
requestBody?: ChangeComplaintStatusModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/complaint-log/{id}/status',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns ModelNote Success
   * @throws ApiError
   */
  public static postComplaintLogNotes(
id: number,
requestBody?: AddNoteModel,
): CancelablePromise<ModelNote> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log/{id}/notes',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postComplaintLogWip(
id: number,
requestBody?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log/{id}/wip',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns FileModel Success
   * @throws ApiError
   */
  public static postComplaintLogFiles(
id: number,
formData?: {
file?: Blob;
},
): CancelablePromise<FileModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log/{id}/files',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param fileId 
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteComplaintLogFiles(
fileId: number,
id: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/complaint-log/{id}/files/{fileId}',
      path: {
        'fileId': fileId,
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns AiAdviceModel Success
   * @throws ApiError
   */
  public static postComplaintLogAiAdvice(
id: number,
requestBody?: AiAdviceRequestModel,
): CancelablePromise<AiAdviceModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log/{id}/ai-advice',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postComplaintLogAiSave(
id: number,
requestBody?: SaveAiReplyModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/complaint-log/{id}/ai-save',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
